import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

type FlexiblePagePasswordProps = {
  password: string;
  pageId: string;
  inPreview: boolean;
};

export function FlexiblePagePassword({ password, pageId, inPreview }: FlexiblePagePasswordProps) {
  const [inputPassword, setInputPassword] = useState('');
  const [hasError, setHasError] = useState(false);
  const [isClient, setIsClient] = useState(false);

  const cookieKey = `_mutinyFlexiblePagePassword_${pageId}`;
  const isAuthenticated = isClient ? Cookies.get(cookieKey) === 'true' : true;

  const shouldShowModal = !isAuthenticated && !inPreview;

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (shouldShowModal) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [shouldShowModal]);

  const handleSubmit = () => {
    if (inputPassword === password) {
      Cookies.set(cookieKey, 'true', { expires: 365 });
      window.location.reload();
    } else {
      setHasError(true);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  if (!shouldShowModal) {
    return null;
  }

  return (
    <>
      <div className="fixed top-0 left-0 right-0 bottom-0 backdrop-blur-[15px] z-40" />
      <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center z-50">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
          <div className="p-4 border-b border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900">Password protected</h3>
          </div>
          <div className="p-4">
            <label htmlFor="password" className="text-base font-semibold text-gray-900 mb-2 block">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={inputPassword}
              onChange={(e) => {
                setInputPassword(e.target.value);
                if (hasError) {
                  setHasError(false);
                }
              }}
              onKeyDown={handleKeyDown}
              placeholder="Enter password"
              className="w-full border border-gray-300 rounded px-4 py-2 text-base focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-transparent"
            />
            {hasError && <p className="text-red-600 text-sm mt-2">Incorrect password</p>}
          </div>
          <div className="p-4 border-t border-gray-200">
            <button type="button" onClick={handleSubmit} className="w-full btn-primary">
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
